import { CounterParty } from '../counter-party.model'
import { TransactionTypeKey } from '../transaction-type.model'
import { AggInfo, AggInfoJson } from './security-transfer/aggInfo.model'
import { BasisCostAndPrice } from './security-transfer/basic-cost-and-price.model'
import { TransferPurchaseInfo } from './security-transfer/transfer-purchase-info.model'
import { TransactionTypeLabel } from './transaction'

/** This is an api model for external unmatched transactions */
export interface ExternalUnmatchedTransaction {
  externalTransactionId: number
  executionId: number
  accountId: number
  entryDate: string // isodate
  settleDate: string // isodate
  postDate: string // isodate
  amount: number

  cusip?: string
  price?: number
  units: number
  accruedAmount?: number
  counterParty?: string
  clearwaterCounterParty?: CounterParty
  currencyId?: number
  inventoryType?: string
  alternateId?: string
  fromAlternateId?: string

  securityId?: number
  fromSecurityId?: number
  fromUnits?: number
  fromAmount?: number
  dataSourceTypeId: ExternalDataSourceTypeId
  tranType: TransactionTypeKey
  accountingBasesToTpi?: { [key: number]: TransferPurchaseInfo }
  aggInfo?: AggInfo
  aggInfoJson?: AggInfoJson
  maturityDate?: string
  unfactorizedUnits?: number
  commission?: number
  originationFee?: number
  exitFee?: number
  exitFeeReceivable?: number
  drawFee?: number
  prepaymentPenaltyFee?: number
  prepaidInterest?: number
  interestDue?: number
  interestBearingInterestReserve?: number
  interestBearingPrincipalReserve?: number
  nonInterestBearingInterestReserve?: number
  nonInterestBearingPrincipalReserve?: number
  balanceToAdjust?: string
  loanFeeType?: string

  basisCostAndPrice?: { [key: number]: BasisCostAndPrice }
  calcUnits?: number
  transferPrice?: number
  assetId?: string
  cwanIdentifier?: string
  factor?: number
  secMasterCurrencyId?: number
  dataSource?: string
  custodyLotIdentifier?: string
  isCapitalize?: boolean
  transactionTypeLabel?: TransactionTypeLabel
}

export enum ExternalDataSourceTypeId {
  Custody = 1,
  Trading = 2,
  Unknown = -1,
}

export type ExternalDataSourceTypeName = keyof typeof ExternalDataSourceTypeId
